export let config = {
    
    BASE_URL: 'https://t6udbwrwi8.execute-api.us-east-1.amazonaws.com/dev/',
    ENDPOINT_SIGNUP:'web/merchant/unsigned/register'
}